import { Controller } from '@hotwired/stimulus'
import { useDebounce } from 'stimulus-use'
import { sendError } from '../../utils'

export default class extends Controller {
  static debounces = ['checkAvailability']
  static targets = ['input', 'error']
  static values = {
    url: { type: String },
    minLength: { type: Number, default: 2 },
    debounceTimeout: { type: Number, default: 250 },
  }

  connect() {
    useDebounce(this, { wait: this.debounceTimeoutValue })

    // Une erreur rendue par le serveur doit aussi bloquer le submit suivant.
    const serverError = this.errorTarget.innerText.trim()
    if (serverError) this.inputTarget.setCustomValidity(serverError)
  }

  checkAvailability(event) {
    if (this.inputTarget.value.length < this.minLengthValue) {
      this.#clearError()
      return
    }

    fetch(this.#url)
      // No network, no answer: the server checks the nickname again on submit.
      .catch(() => null)
      .then((res) => {
        if (!res) return { available: true }
        // An expired session answers with HTML: parsing it is not the error.
        if (!res.ok) throw new Error(`Nickname check failed with status ${res.status}`)
        return res.json()
      })
      .then((data) => {
        if (data.available) {
          this.#clearError()
        } else {
          this.#displayError(data.message)
        }
      })
      .catch((error) => {
        this.#clearError()
        console.error(error)
        sendError(error, this.identifier, { url: this.#url.toString() })
      })
  }

  #displayError(message) {
    this.errorTarget.innerText = message
    this.errorTarget.classList.remove('hidden')
    this.inputTarget.ariaInvalid = true
    this.inputTarget.setCustomValidity(message)
  }

  #clearError() {
    this.errorTarget.innerText = ''
    this.errorTarget.classList.add('hidden')
    this.inputTarget.ariaInvalid = false
    this.inputTarget.setCustomValidity('')
  }

  get #url() {
    const uri = new URL(this.urlValue, document.location)
    uri.searchParams.set('nickname', this.inputTarget.value)
    return uri
  }
}
